import { render, staticRenderFns } from "./EventDetailsOverlay.vue?vue&type=template&id=007ba44c&scoped=true&"
import script from "./EventDetailsOverlay.vue?vue&type=script&lang=js&"
export * from "./EventDetailsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailsOverlay.vue?vue&type=style&index=0&id=007ba44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ba44c",
  null
  
)

export default component.exports